import styled, { css } from 'styled-components';
import screen from 'superior-mq';
import { bp } from 'Styles/helpers';

const Section = styled.section`
  padding: 160px 0;

  ${screen.below(bp.desktop, `
    padding: 120px 0;
  `)}

  ${screen.below(bp.laptopSm, `
    padding: 100px 0;
  `)}

  ${screen.below(bp.tablet, `
    padding: 80px 0;
  `)}

  ${props => props.dark && css`
    --anchor-hover-color: ${props.theme.white};
    background-color: ${props.theme.black};
    color: #fff;
  `}

  ${props => props.styles && css`
    ${props.styles}
  `}
`;

export default Section;
